import React from "react";
import { Field, PanelSection } from "./StudioControls";
import { ROLES, priceText } from "./studioModel";
import { styleGroupIds, styleGroupName } from "./studioStyleGroups";
import { fitPriceFrames } from "./studioTextFit";
import { linkContent } from "./studioContentLinks";

export default function StudioContentLink({ node, doc, menus, content, commit }) {
  const sources = Object.entries(menus || {}).flatMap(([menu, value]) => (value.sections || []).flatMap((section) => [
    { key: `section:${section._id}`, label: `${menu} · ${section.header}`, source: section, type: "section" },
    ...(section.items || []).map((item) => ({ key: `item:${item._id}`, label: `${section.header} · ${item.name}`, source: item, type: "item" })),
  ]));
  const [type, id, field] = (node.binding || "").split(":");
  const sourceKey = id ? `${type}:${id}` : "";
  const linked = sources.find((entry) => entry.key === sourceKey);
  const fields = type === "section" ? ["header", "description"] : ["name", "description", "price", "modifiers", "sauceNames", "saucePrices", "sizeLabels"];
  const memberships = Object.keys(ROLES).filter((role) => styleGroupIds(doc, role).includes(node.id));
  const changeLink = (binding) => commit((previous) => fitPriceFrames({ ...previous, pages: previous.pages.map((page) => ({ ...page, elements: page.elements.map((n) => n.id === node.id ? linkContent(n, binding, content) : n) })) }, content));
  return <PanelSection title="Content & typography">
    <Field label="CMS source">
      <select value={sourceKey} onChange={(e) => {
        const source = sources.find((entry) => entry.key === e.target.value);
        const nextField = source?.type === "section" ? (field === "description" ? field : "header")
          : ["name", "description", "price", "modifiers", "sauceNames", "saucePrices", "sizeLabels"].includes(field) ? field : node.role === "price" ? "price" : node.role === "description" ? "description" : "name";
        changeLink(source ? `${source.key}:${nextField}` : "");
      }}>
        <option value="">Independent text</option>
        {sourceKey && !linked && <option value={sourceKey}>Unavailable CMS source</option>}
        {sources.map((entry) => <option key={entry.key} value={entry.key}>{entry.label}</option>)}
      </select>
    </Field>
    {sourceKey && <Field label="Content field"><select value={field} onChange={(e) => changeLink(`${sourceKey}:${e.target.value}`)}>
      {fields.map((key) => <option key={key} value={key}>{key.charAt(0).toUpperCase() + key.slice(1)}</option>)}
    </select></Field>}
    {linked && <div className="ms-linked-item-summary">
      <strong>{linked.source.name || linked.source.header}</strong>
      <p>{linked.source.description || "No description"}</p>
      {linked.type === "item" && <span>{priceText(linked.source)}</span>}
      {linked.type === "item" && ["options", "sauces", "pastas", "platters"].map((key) => linked.source[key]?.some((entry) => entry.name?.trim()) &&
        <p key={key}>{key}: {linked.source[key].filter((entry) => entry.name?.trim()).map((entry) => `${entry.name}${entry.price ? ` +${entry.price}` : ""}`).join(" · ")}</p>)}
    </div>}
    <Field label="Typography group"><select value={memberships.includes(node.role) ? node.role : memberships[0] || ""} onChange={(e) => {
      const role = e.target.value;
      commit((previous) => fitPriceFrames({ ...previous,
        styleGroups: Object.fromEntries(Object.keys(ROLES).filter((key) => key !== "decoration").map((key) => {
          const group = previous.styleGroups?.[key] || {};
          return [key, { name: ROLES[key], ...group, included: (group.included || []).filter((value) => value !== node.id),
            excluded: [...(group.excluded || []).filter((value) => value !== node.id), ...(!role ? [node.id] : [])] }];
        })),
        pages: previous.pages.map((page) => ({ ...page, elements: page.elements.map((n) => n.id === node.id && role ? { ...n, role, style: {} } : n) })),
      }, content));
    }}><option value="">Individual typography</option>{Object.keys(ROLES).filter((key) => key !== "decoration").map((role) => <option key={role} value={role}>{styleGroupName(doc, role)}</option>)}</select></Field>
    {memberships.length > 1 && <p className="ms-hint">Also linked: {memberships.filter((role) => role !== node.role).map((role) => styleGroupName(doc, role)).join(", ")}</p>}
  </PanelSection>;
}
